import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { trackEvent, useParamsState } from '@/helpers'
import { ROUTES_ADMIN } from '@/router'
import { useTransportCompanyDetail } from '@/services'
import { Button, ChevronLeftIcon, Text } from '@mercai/clever'

import { DrawerLogisticPartnerForm, TableLogisticRoutes } from '../components'

import { getTabsItems } from './show.constants'

import styles from './show.module.css'

export const SupplyTransportCompaniesShow = () => {
  const { t } = useTranslation('screenLogistic')

  const { uuid } = useParams()

  const [queryParams, setQueryParams] = useParamsState({
    uuid: '',
    show: '',
    form: '',
    tab: 'routes',
  })

  const { data } = useTransportCompanyDetail(uuid)

  const onHandleEditRegister = (uuid: string) => {
    setQueryParams({ ...queryParams, form: 'true', show: '', uuid })
  }

  const tabsComponents: Record<string, React.ReactNode> = {
    routes: (
      <TableLogisticRoutes
        transportCompanyUuid={uuid || ''}
        isImporter={data?.data?.type === 'import_company'}
      />
    ),
  }

  useEffect(() => {
    trackEvent('adminTransportCompaniesShowPageView')
  }, [])

  return (
    <div className={styles.container}>
      <section className={styles['header-section']}>
        <div className={styles['header-left-sidebar']}>
          <a href={`/${ROUTES_ADMIN.SUPPLY.ADMIN_LOGISTIC.path}`}>
            <ChevronLeftIcon />
          </a>
          <div>
            <Text>
              <strong>{`${t('title')} / `}</strong>
              <Text>{data?.data?.name}</Text>
            </Text>
            <div className={styles.title}>
              <Text variant="title-large">{data?.data?.name}</Text>
            </div>
          </div>
        </div>
        <Button onClick={() => onHandleEditRegister(uuid || '')}>
          {data?.data?.type === 'transport_company'
            ? t('tabLogisticCarriersUpdate')
            : t('tabLogisticImportersUpdate')}
        </Button>
      </section>

      <div className={styles.content}>
        <section className={styles['tab-filter']}>
          {getTabsItems(t).map((tabItem) => (
            <Button
              model="pill"
              variant={
                queryParams.tab === tabItem.key ? 'primary' : 'secondary'
              }
              key={tabItem.key}
              onClick={() =>
                setQueryParams({ ...queryParams, tab: tabItem.key })
              }
            >
              {tabItem.title}
            </Button>
          ))}
        </section>
        <section>{tabsComponents?.[queryParams?.tab || 'routes']}</section>
      </div>

      {data?.data && (
        <DrawerLogisticPartnerForm
          isOpen={!!queryParams.form}
          onHandleOpen={() =>
            setQueryParams({ ...queryParams, form: '', uuid: '' })
          }
          transportCompany={data?.data}
          isImporter={data?.data?.type === 'import_company'}
        />
      )}
    </div>
  )
}
